import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { hasRole } from "@data/utility/ability"
import { opensStudentShell } from "../main-menu/studentShell"
import { tutorShellFor } from "../main-menu/tutorShell"
import React, { useContext } from "react"
import { Dimensions, Platform, View } from "react-native"
import { ActivityIndicator, Appbar } from "react-native-paper"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { connect } from "react-redux"
import { theme } from "../theme/theme"
import LiveModeHeader from "./LiveModeHeader"
import StudentMainMenuHeader from "./StudentMainMenuHeader"
import TutorMainMenuHeader from "./TutorMainMenuHeader"

const Header = (props) => {
    const { navigation, route, options, back } = props

    const title =
        options.headerTitle !== undefined
            ? options.headerTitle
            : options.title !== undefined
              ? options.title
              : route.name

    const insets = useSafeAreaInsets()

    const isStudent = hasRole(props.user, "student")

    const goToAccount = () => {
        navigation.push("settings", { initialTab: 0 })
    }

    const dimensions = useContext(DimensionsContext)

    // L'espace élève du design system porte son propre en-tête, dans chaque onglet
    // (`StudentNavigator`) : la route `menu` n'en pose pas d'autre au-dessus.
    if (route.name === "menu" && opensStudentShell(props.user, props.isLiveMode)) {
        return null
    }
    // De même pour l'espace tuteur, et pendant l'attente de son interrupteur (son chargement n'a pas
    // d'en-tête) ; éteint, rien ne change.
    if (route.name === "menu" && props.tutorShell !== "off") {
        return null
    }

    return (
        <View
            style={{
                width: Dimensions.get("window").width,
                alignSelf: "center",
                backgroundColor: theme.colors.white,
            }}
        >
            {!props.isLiveMode ? (
                route.name === "menu" ||
                route.name === "not-found" ||
                options.headerTitle === "Non autorisé" ? (
                    <>
                        <Appbar.Header
                            theme={{
                                colors: { primary: theme.colors.white },
                            }}
                            style={{
                                padding: 0,
                                backgroundColor: theme.colors.white,
                                elevation: 0,
                                borderBottomWidth: 1,
                                borderColor: theme.colors.lighter,
                            }}
                            statusBarHeight={insets.top}
                        >
                            {isStudent ? (
                                <StudentMainMenuHeader />
                            ) : (
                                <TutorMainMenuHeader />
                            )}
                        </Appbar.Header>
                    </>
                ) : (
                    <Appbar.Header
                        theme={{ colors: { primary: theme.colors.white } }}
                        style={{
                            padding: 0,
                            backgroundColor: theme.colors.white,
                            elevation: 0,
                            borderBottomWidth: 1,
                            borderColor: theme.colors.lighter,
                        }}
                        statusBarHeight={insets.top}
                    >
                        {back && Platform.OS !== "web" && (
                            <Appbar.BackAction
                                onPress={navigation.goBack}
                                color={theme.colors.primary}
                            />
                        )}

                        <Appbar.Content
                            title={title}
                            color={theme.colors.primary}
                            titleStyle={{
                                fontFamily: "Montserrat-Bold",
                            }}
                        />
                        {route.name === "account" && (
                            <Appbar.Action
                                icon={"cog"}
                                color={theme.colors.primary}
                                onPress={goToAccount}
                            />
                        )}
                        {route.name === "settings" && (
                            <Appbar.Action
                                icon={"save"}
                                color={theme.colors.primary}
                                onPress={goToAccount}
                            />
                        )}
                    </Appbar.Header>
                )
            ) : null}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        successes: state.data.staticData?.successes,
        getStaticDataRequest: state.api.getStaticData?.request,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        subscribeToNotificationsRequest:
            state.api.subscribeToNotifications?.request,
        isLiveMode: state.liveMode?.isLiveModeEnabled,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        liveSessionId: state.liveMode?.liveSessionId,
        tutorShell: tutorShellFor(state),
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
